import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import './index.css';
import './styles/global.css';  // Import our global healthcare theme styles
import App from './App';
import * as serviceWorker from './serviceWorker';

// render micro frontend function
window.rendersubapp1 = (containerId, history) => {
  const container = document.getElementById(containerId);
  const root = createRoot(container);
  root.render(
    <ConfigProvider>
      <App history={history} />
    </ConfigProvider>
  );
  serviceWorker.unregister();
};

// unmount micro frontend function
window.unmountsubapp1 = containerId => {
  const container = document.getElementById(containerId);
  const root = createRoot(container);
  root.unmount();
};

// Mount to root if it is not a micro frontend
if (!document.getElementById("subapp1-container")) {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <ConfigProvider>
      <App />
    </ConfigProvider>
  );
}

serviceWorker.unregister();